<template>
	<PageDefault :gradient="stationData?.uaqi?.main">
		<TopControls>
			<template #left>
				<button outline @click="router.go(-1)">
					<FontAwesomeIcon :icon="faAngleLeft" />
					<span>Назад</span>
				</button>
			</template>
			<template #right>
				<button outline @click="goToSection(sectionRealtime)">
					<FontAwesomeIcon :icon="faCircleDot" :fade="true" />
					<span>Поточні дані</span>
				</button>
				<button outline @click="goToSection(sectionStatistics)">
					<FontAwesomeIcon :icon="faChartLine" />
					<span>Статистика</span>
				</button>
				<button outline @click="goToSection(sectionArchives)">
					<FontAwesomeIcon :icon="faFileZipper" />
					<span>Архіви</span>
				</button>
			</template>
		</TopControls>

		<br />
		
		<div v-if="stationData != null">
			<h1>
				<FontAwesomeIcon :icon="getStationIcon(stationData)" />
				{{ stationData?.name }}
			</h1>
			<p>Станція моніторингу якості повітря</p>
			<br/>
			
			<div ref="sectionRealtime">
				<h2>Поточні дані</h2>
		
				<div v-if="showRealtime">
					<p>Значення забрудників на момент {{ stationData?.last_online }}</p>
					
					<div class="flex flex-row gap-1 overflow-x-auto">
						<PollutantValue 
							v-for="p in pollutantsFiltered"
							:key="p"
							:pollutant=p
						/>
					</div>
				</div>
				<div v-else>
					<p>Станція востаннє була онлайн занадто давно(</p>
				</div>
			</div>

			<br/>
		</div>
		<div v-else>
			<h2 class="mt-8">
				<SkeletonLoader class="h-8 w-[40%]"/>
			</h2>

			<SkeletonLoader class="h-4 w-[30%]"/>

			<br><br><br>

			<h2>
				<SkeletonLoader class="h-6 w-[45%]"/>
			</h2>

			<div>
				<SkeletonLoader class="h-4 w-[80%]"/>
			</div>

			<br>

			<div class="flex flex-row gap-1 overflow-x-auto">
				<SkeletonLoader class="h-[140px] w-full"/>
				<SkeletonLoader class="h-[140px] w-full"/>
				<SkeletonLoader class="h-[140px] w-full"/>
				<SkeletonLoader class="h-[140px] w-full"/>
			</div>

			<br>
		</div>
		
		<div ref="sectionStatistics">
			<h2>Статистика</h2>
	
			<div v-if="toOldForStatistics">
				<p>
					Станція востаннє була онлайн настільки давно, що в нас 
					нема даних навіть за останній місяць(
				</p>
			</div>
			<div v-else>
				<StationStats :id="props.id" :station-data="stationData"/>
				<br/>
			</div>
			
			<br/>
		</div>
	
		<div ref="sectionArchives">
			<h2>Завантаження архівів даних</h2>
			<p>
				Колись тут буде можливість завантажити дані зі станції)
			</p>
		</div>
		
		<br/><br/>
		<br/><br/>
	</PageDefault>
</template>

<script setup>
import { ref, defineProps, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'

import PageDefault from '@/components/ui/PageDefault.vue'
import TopControls from '@/components/ui/TopControls.vue'
import SkeletonLoader from '@/components/ui/SkeletonLoader.vue'
import PollutantValue from '@/components/PollutantValue.vue'
import StationStats from '@/components/StationStats.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faAngleLeft,
	faCircleDot,
	faChartLine,
	faFileZipper, 
} from '@fortawesome/free-solid-svg-icons'

import { getStationIcon } from '@/modules/StationIcon'

import axios from 'axios'
import { differenceInHours, differenceInDays } from 'date-fns';

const router = useRouter()

const props = defineProps({ id: String })

const stationData = ref(null)

const sectionRealtime = ref(null)
const sectionStatistics = ref(null)
const sectionArchives = ref(null)

function goToSection(section) {
	section.scrollIntoView({ behavior: 'smooth' })
}

const pollutantsFiltered = computed(() => {
	if (stationData.value == null) return []

	const pollutantsToHide = [ "Temperature", "Humidity", "Pressure" ]
	return [...stationData.value.current_values]?.filter(e => !pollutantsToHide.includes(e.type));
})

const showRealtime = computed(() => {
	if (stationData.value == null) return false

	const diffInHours = differenceInHours(stationData.value.last_online, new Date());

	return diffInHours > -3
})

const toOldForStatistics = computed(() => {
	if (stationData.value == null) return false

	const diffInHours = differenceInDays(stationData.value.last_online, new Date());

	return diffInHours < -30
})

const fetchStation = async () => {
	try {
		const response = await axios.get(`/api/v1/station?id=${props.id}`)
		stationData.value = response.data
	} catch (error) {
		console.error('Error fetching STATION: ', error)
	}
}

onMounted(() => {
	fetchStation()
})
</script>

<style scoped>

</style>